// import { User } from '../main';

import { User } from "./user";

export class Comment {
    id!: number;
    user!: User;
    created_at!: string;
    created_at_date!: Date;
    updated_at!: string;
    updated_at_date!: Date;
    parent: Comment | null = null;
    root_parent: Comment | null = null;
    text!: string;
    replies!: number;

    static fromObject(obj: Record<string, any>): Comment {
        const comment = Object.setPrototypeOf(obj, Comment.prototype);
        comment.user = User.fromObject(comment.user);
        comment.parent ??= null;
        comment.root_parent ??= null;
        if (comment.parent) {
            comment.parent = Comment.fromObject(comment.parent);
        }
        if (comment.root_parent) {
            comment.root_parent = Comment.fromObject(comment.root_parent);
        }
        comment.created_at_date = new Date(comment.created_at);
        comment.updated_at_date = new Date(comment.updated_at);
        return comment;
    }
}
